import * as echarts from "echarts";
let create = function (category, data, config) {
  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: [
      {
        type: "category",
        data: category,
        axisTick: {
          alignWithLabel: true
        }
      }
    ],
    yAxis: [
      {
        type: "value"
      }
    ],
    series: [
      {
        name: "总数",
        type: "bar",
        itemStyle: {
          color: config.Theme === '渐变' ? new echarts.graphic.LinearGradient(
            0, 0, 0, 1, [{//代表渐变色从正上方开始
              offset: 1, //offset范围是0~1，用于表示位置，0是指0%处的颜色
              color: config.Colors[0]
            }, //柱图渐变色
            {
              offset: 0, //指100%处的颜色
              color: config.Colors[1]
            }
          ]
          ) : config.Color
        },
        barWidth: 20,
        barCategoryGap: "40%",
        data: data
      }
    ]
  };
};

export default { create };
